const SORT_ORDERS = ["asc", "desc"];

export const getSortOrder = (orderBy) => {
  const sortOrder = {};

  if (!Array.isArray(orderBy)) return sortOrder;

  orderBy.forEach((orderByField) => {
    const parts = orderByField.split(" ");

    if (!SORT_ORDERS.includes(parts[1])) return;

    sortOrder[parts[0]] = parts[1] === "asc" ? "ascend" : "descend";
  });

  return sortOrder;
};
